<template>
  <div :class='[ !showRotateTips ? "explore-share" : "explore-screen"]'>
    <div class="report-share" @click="handleExploreShare">
      <img src="@/assets/images/hor-screen/icShare.png" alt="" class='is-share' v-if="isInApp">
      <span>{{isInApp ? 'Share': 'Explore Trucker Path'}}</span>
    </div>
    <pop-up :value="currentValue" :handleTogglePopup="handleTogglePopup">
      <ul class="report-share-options">
        <li @click="openSharePage('facebook')">
          <img src="@/assets/images/year-review/facebook@2x.png" alt="">
          <span>Facebook</span>
        </li>
        <li @click="openSharePage('twitter')">
          <img src="@/assets/images/year-review/twitter@2x.png" alt="">
          <span>Twitter</span>
        </li>
        <!-- <li @click="handleSaveImage">
          <img src="@/assets/images/year-review/save@2x.png" alt="">
          <span>Save Image</span>
        </li> -->
      </ul>
      <button class="report-share-cancel" @click="handleTogglePopup(false)"> Cancel</button>
    </pop-up>
    <!-- <save-image :value="saveImagePop" :handleToggleImage="handleToggleImage">
      <div class="report-image">
        <img :src="pageUrl" alt="">
      </div>
    </save-image> -->
  </div>
</template>
<script>
import popUp from './popup.vue'
// import html2canvas from 'html2canvas'
// import saveImage from './saveImage.vue'
import mixpanel from "@/utils/mixpanel.js";
import cookie from 'cookiejs';
import { getMobelType } from '@/utils/getMobelType.js'
export default {
  name: 'explore-share',
  components:{
    popUp
    // saveImage
  },
  props: {
    isInApp:{
      type: Boolean,
      required: false,
      default: true
    },
    querys: {
      type: Object,
      required: false,
    },
    showRotateTips:{
      type:Boolean
    }
  },
  data(){
    return {
      version: {},
      // isInApp : true,
      currentValue: false,
      saveImagePop: false,
      browserInfo: {},
      pageUrl: '',
      title: 'Truck path app share.title',
      href: 'https://www.baidu.com',
      deepLinkUrl: "truckerpath://h5?url="
    }
  },
  created(){
    this.browserInfo = this.browserType();
  },
  mounted() {
    this.version = getMobelType()
  },
  methods: {
    handleExploreShare(){
      const fn = this.isInApp ? 'handleShare' : 'handleOpenApp';
      // console.log(fn,'...')
      this[fn]()
    },
    handleOpenApp(e) {
      e = e || window.event
      var timeout = 5300, timer = null;
      const href = encodeURIComponent(document.location.href) || `${this.href}`
      mixpanel.track('User Growth Campaign', { 'Outcome': 'Explore TP' ,'Campaign name': '2019 Year in Review','View Type': 'Sharing view'})
      if (this.version.weixin) {
        this.isOpenBrowser = true
      } else {
        var startTime = Date.now()
        if (this.version.android) {
          // console.log(this.deepLinkUrl,'....this.deepLinkUrl')
          //埋点
          if(e.preventDefault) {
            e.preventDefault();
          }else{
            e.returnValue = false;
          }
          window.open(this.deepLinkUrl + href + '&time='+Date.now(), '_self') //唤起协议，由iOS小哥哥提供
          timer = setTimeout(() => {
            let endTime = Date.now()
            if (!startTime || endTime - startTime < timeout + 100) {
              window.open('https://play.google.com/store/apps/details?id=com.sixdays.truckerpath')
            }
          }, timeout)
        }
        if (this.version.ios || this.version.iPhone || this.version.iPad) {
          if (this.version.qq) {
            this.isOpenBrowser = true
          } else {
            window.open(this.deepLinkUrl + '?utm_source=share&time=' + Date.now(), '_self') //唤起协议，由iOS小哥哥提供
            timer = setTimeout(() => {
              let endTime = Date.now()
              if (!startTime || endTime - startTime < timeout + 100) {
                window.open('https://apps.apple.com/cn/app/truckerpath/id782746890')
              }
            }, timeout)
          }
        }
      }
      document.addEventListener('visibilitychange webkitvisibilitychange', function() {
        var tag = document.hidden || document.webkitHidden
        if (tag) {
          clearTimeout(timer)
        }
      })
      window.addEventListener('pagehide', function() {
        clearTimeout(timer)
      })
    },
    openSharePage(type) {
      const toOpen = function(url) {
        const option =
          'toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350'
        window.open(url, '_blank', option)
      }
      const query  = this.translateQuery(this.querys)
      const href = document.location.href || `${this.href}`
      const title = this.title
      // console.log(query,'....openSharePage内的参数')
      switch (type) {
      case 'facebook': // 分享到Facebook的代码
        // console.log(query,'.....facebook query')
        mixpanel.track('User Growth Campaign', { 'Outcome': 'Facebook' ,'Campaign name': '2019 Year in Review','View Type': 'User view'})
        toOpen('http://www.facebook.com/sharer.php?u=' + href +'&' + query)
        this.handleTogglePopup(false)
        break
      case 'twitter': // 分享到twitter的代码
        mixpanel.track('User Growth Campaign', { 'Outcome': 'Twitter' ,'Campaign name': '2019 Year in Review','View Type': 'User view'})
        toOpen('https://twitter.com/intent/tweet?url='+href+ '&' + query)    
        this.handleTogglePopup(false)
        break
      case 'ins': // 分享到ins
        toOpen('http://www.linkedin.com/shareArticle?mini=true&url=' + href + '&title=' + title)
        break
      }
    },
    browserType() {
      var u = window.navigator.userAgent
      return {
        isAndroid: u.indexOf('Android') > -1, //android终端或者uc浏览器
        isIPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者安卓QQ浏览器
      }
    },
    handleShare(){
      mixpanel.track('User Growth Campaign', { 'Outcome': 'Share' ,'Campaign name': '2019 Year in Review','View Type': 'User view'})
      let versionAndriod = cookie.get('tp-version-code') ? cookie.get('tp-version-code') : 0
      let href = window.location.href.indexOf('?') >-1 ? window.location.href + '&' + this.translateQuery(this.querys) : window.location.href + '?' +this.translateQuery(this.querys) 
      // console.log(window,'.....window')
      // console.log(window.WebViewJavascriptBridge,'......window.WebViewJavascriptBridge')
      // console.log(window.WebViewJavascriptBridge.callHandler)
      // console.log(cookie.get('tp-version-code'),'......tp-version-code')
      // console.log( window.location.href + '?'+ this.translateQuery(this.querys))
      // console.log(this.translateQuery(this.querys),'....this.translateQuery(this.querys)')
      if(
        this.browserInfo.isIPhone && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.share && window.webkit.messageHandlers.share.postMessage
      ){
        // console.log(this.querys, 'ios share this.querys');
        // console.log(this.translateQuery(this.querys), 'ios share translate this.querys');
        // console.log(window.location.href + '?'+ this.translateQuery(this.querys),'.....window.location.href + this.translateQuery(this.querys)')
        
        window.webkit.messageHandlers.share.postMessage({"url" : href });
      }else if(this.browserInfo.isAndroid && Number(versionAndriod) >= 3820){
        window.WebViewJavascriptBridge.callHandler(
          'share'
          , {"url": href }
          , function(responseData) {
            //console.log(responseData,'....responseData')
            alert('success')
          });
      }else{
        this.handleTogglePopup(true)
        // this.showCard = true;
      }
    },
    handleTogglePopup(flag){
      this.currentValue = flag
    },
    handleToggleImage(flag){
      this.saveImagePop = flag
    },
    // handleSaveImage(){
    //   this.saveImgFlag = false
    //   let that = this;
    //   this.$nextTick(()=>{
    //     //
    //     //
    //     let yearReport = document.getElementById("yearReport");
    //     let yearStatic = document.getElementById("yearStatic");
    //     let yearReportClone = yearReport.cloneNode(true);
    //     let yearStaticClone = yearStatic.cloneNode(true)
    //     const cloneParent = document.createElement('div')
    //     cloneParent.id = 'cloneParent'
    //     cloneParent.appendChild(yearReportClone)
    //     cloneParent.appendChild(yearStaticClone)
    //     cloneParent.style.cssText ="background-color: #fafafa; position: absolute;top: 0px;z-index: -1;height: 798;width: 650";
    //     document.body.appendChild(cloneParent)
    //     setTimeout(item=>{
    //       html2canvas(document.getElementById("cloneParent"),{ 
    //         scale: 1 }).then(function(canvas) {
    //         that.pageUrl = canvas.toDataURL("image/png");
    //         that.saveImagePop = true;
    //         document.body.removeChild(cloneParent)
    //
    //       });
    //     },100)
    //   })

    //   // //设置克隆节点的z-index属性，只要比被克隆的节点层级低即可。
    //   // cloneDom.css({
    //   //     "background-color": "#fafafa",
    //   //     "position": "absolute",
    //   //     "top": "0px",
    //   //     "z-index": "-1",
    //   //     "height": 798,
    //   //     "width": 650
    //   // });
     
    //   this.handleTogglePopup(false)
    // },
    translateQuery(obj){
      return obj && Object.keys(obj).length ? Object.keys(obj).map(function (key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(obj[key]));
      }).join('&'): ''
    }
  }
}
</script>
<style lang="scss">
  @import '@/scss/rem.scss';

  $rem: 66.7px;
  html{
    font-size: $rem;
  }
  @function remHos($px) {
    @return $px / $rem * 1rem;
  }
  .explore-share{
    width: 100%;
    position: absolute;
    bottom: rem(15px);
    left: 0;
    z-index: 10000;
    padding: 0 rem(25px);
  }
  .is-share{
    width:rem(17.5px);
    height:rem(14.5px);
    margin-right:rem(10px);
  }
  .explore-screen{
    width: 100%;
    padding: 0 remHos(25px);
    padding-bottom:remHos(25px);
    box-sizing: border-box;
    .is-share{
      width:remHos(17.5px);
      height:remHos(14.5px);
      margin-right:remHos(10px);
    }
    .report-share{
      height: remHos(43px);
      font-size: remHos(16px);
      border-radius: remHos(5px);
    }
    .report-share-options{
      padding: remHos(20px) 0; 
      >li{
        >span{
          font-size: remHos(11px);
        }
        >img{
          margin-bottom: remHos(10px);
          width: remHos(60px);
        }
      }
    }
    .report-share-cancel{
      height: rem(50px);
      line-height: rem(50px);
      border-top: rem(0.5px) solid #eee;
      text-align: center;
      background: #fff;
      color: rgb(0,122,255);
      font-size: rem(17px);
    }
  }
  .report-share{
    display: flex;
    justify-content: center;
    align-items: center; 
    width:100%;
    height: rem(43px);
    color: #ffffff;
    font-family: Gotham-Book;
    font-size: rem(16px);
    border-radius: rem(5px);
    background: rgb(3,118,239);
    box-shadow: 0 rem(10px) rem(30px) rgba(3,128,239,0.56);

  }
  .report-share-options{
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: rem(20px) 0; 
    >li{
      width: 33%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      >span{
        font-size: rem(11px);
        color: #333;
      }
      >img{
        margin-bottom: rem(10px);
        width: rem(60px);
      }
    }
  }
  .report-share-cancel{
    width: 100%;
    height: rem(50px);
    line-height: rem(50px);
    border-top: rem(0.5px) solid #eee;
    text-align: center;
    background: #fff;
    color: rgb(0,122,255);
    font-size: rem(17px);
    cursor: pointer;
  }
  .report-image{
    width: 100%;
    height: 100%;
    // overflow: auto;
    >img{
      height: 100%;
    }
  }
  // .img{
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   right: 0;
  //   bottom :0;
  //   width: 100%;
  //   >img{
  //     width: 100%;
  //   }
  // }
</style>
